

export var DataArray = {
    stateList: [
        { text: "Gujarat" },
        { text: "Madhya Pradesh" },
        { text: "Maharashtra" },
        { text: "Rajasthan" },
    ],

    nonExecutiveDesignationList: [
        { text: "Additional Director" },
        { text: "Alternate Director" },
        { text: "Director" },
        { text: 'Director Appointed in Casual Vacancy' },
        { text: "Nominee Director" }
    ],

    executiveDesignationList: [
        { text: "Managing Director" },
        { text: "Managing Director (Additional Director)" },
        { text: "Whole Time Director" },
        { text: "Whole Time Director (Additional Director)" }
    ],

    categoryList: [
        { text: "Independent" },
        { text: "Promoter" },
        { text: "Professional" },
    ],

    executiveCategoryList: [     
        { text: "Promoter" },
        { text: "Professional" },
    ],
    cessationTypeList: [
        { text: "Any other" },
        { text: "Death" },
        { text: "Disqualification" },
        { text: "Nomination withdrawn by appointing authority" },
        { text: "Not re-appointed" },
        { text: "Removal" },
        { text: "Resignation" },
        { text: "Retirement" },
        { text: "Vacation of Office" },
    ],

    BodiesCorporate: [
        { text: "Association of Individuals" },
        { text: "Foreign Company" },
        { text: "HUF" },
        { text: "LLP" },
        { text: "OPC" },
        { text: "Others" },
        { text: "Partnership Firm" },
        { text: "Private Debt Listed company (Not a subsidary of Public Company)" },
        { text: "Private Unlisted Company (Not a subsidary of Public Company)"},
        { text: "Private Limited Company" },
        { text: "Proprietorship" },
        { text: "Public Listed Company" },
        { text: "Public Unlisted Company" },
        { text: "Section 8 Company" },
        { text: "Private Debt Listed company (Subsidary of Public Company)" },
        { text: "Private Unlisted Company (Subsidary of Public Company)" }
    ],

    NatureOfIntrest: [
        { text: "Additional Director" },
        { text: "Alternate Director" },
        { text: "CEO" },
        { text: "CFO" },
        { text: "Committee Chairman" },
        { text: "Committee Member" },
        { text: "CS" },
        { text: "Designated Partner" },
        { text: "Director" },
        { text: "Director Appointed in Casual Vacancy" },
        { text: "Karta of HUF" },
        { text: "Manager" },
        { text: "Managing Director" },
        { text: "Member" },
        { text: "Member of AOI" },
        { text: "Member of HUF" },
        { text: "Nominee Director" },
        { text: "Others" },
        { text: "Partner" },
        { text: "Proprietor" },
        { text: "Whole Time Director" },
        { text: "Independent Director"}
    ],

    Relation: [
        { text: "Brother (including step Brother)" },
        { text: "Daughter" },
        { text: "Daughter's husband" },
        { text: "Father (including step father)" },
        { text: "Husband/Wife" },
        { text: "Members of a Hindu Undivided Family" },
        { text: "Mother (including step Mother)" },
        { text: "Sister (including step Sister)" },
        { text: "Son's wife" },
        { text: "Son (including step Son)" }
    ],

    KmpDesignation: [
        { text: "Chief Executive Officer" },
        { text: "Chief Financial Officer" },
        { text: "Company Secretary" },
        { text: "Manager" },
        { text: "Managing Director" },
        { text: "Others" },
        { text: "Whole Time Director" },
    ],

    Institute: [
        { text: "CA" },
        { text: "CFA" },
        { text: "CS" },
        { text: "Others" }
    ],

    Committee: [
        { text: "Audit Committee" },
        { text: "Others" },
        { text: "Stakeholder Relationship Committee" }
    ]
}


